import { NEWS_SUCCESS, NEWS_ERROR } from "./newsActions";

export const news = (state = { newsItems: null, newsError: null }, action) => {
    switch (action.type) {
        case NEWS_SUCCESS:
            return { ...state, newsItems: action.newsItems, newsError: null };

        case NEWS_ERROR:
            return { ...state, newsItems: null, newsError: action.msg };

        default:
            return state;
    }
};
